import React from 'react';
import {FormGroup, Label, Tooltip} from "reactstrap";
import HTML from '../../common/HtmlHelpers';
import AutoComplete from '../../components/AutoCompleteInput';
import {Desktop} from "../../common/ResponsiveUtils";
import AppVariables from "../../common/AppVariables";
import './FormInput.css';
import PropTypes from 'prop-types';
import {ErrorMessage, Field} from "formik";
import PhoneNumberInput from "../PhoneNumberInput/PhoneNumberInput";
import Select, {Async as AsyncSelect, components} from 'react-select';
import _ from 'lodash';
import DatePicker from "react-datepicker";
import moment from "moment";

const Styles = {

    optionalInputLabel:{
        color: "#b0bec5",
        fontSize: 10
    },

    requiredInputLabel:{
        color: "#111111",
        fontSize: 15
    }

};

class FormInput extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            errorMessage: null,
            isTooltipOpen: false
        };

    }

    /**
     * Sets an error message for the input
     * @param errorMessage
     */
    setError(errorMessage){
        this.setState({ errorMessage: errorMessage });
    }

    /**
     * Clears the error message
     */
    clearError(){

        this.setState({
            errorMessage: null
        });

    }

    /**
     * Gets the input control
     * @returns {*}
     */
    getInput(){
        return this._input;
    }

    /**
     * Gets the value of the input
     */
    getValue(form){
        return form.getFormikContext().values[this.props.name];
    }

    /**
     * Sets the value of the input
     * @param value
     */
    setValue(value){

        switch (this.props.type){
            case "location":
                this._input.setLocation(value,arguments[1],arguments[2]);
                break;
            default:
                this._input.value = value;
                break;
        }
    }

    toggleTooltip(){
        this.setState({ isTooltipOpen: !this.state.isTooltipOpen });
    }

    render(){

        const me = this;
        const props = me.props;
        const { showPrompt ,
            showFieldError ,
            className,
            type ,
            title ,
            titleRightContent,
            required ,
            tipError ,
            name ,
            icon,
            items,
            inputClass,
            comment,
            children,
            ...inputProps } = props;

        let input;
        const hasRequired = required === true;

        switch (type){
            case 'select':
                input = <Field name={name}
                               {...inputProps}
                               component="select"
                               className={`form-control form-input-select select-frame ${inputClass}`}
                               innerRef={r => this._input = r}>

                    {items && items.map((item,index) => {
                        return <option key={index} value={item.value}>{item.text}</option>
                    })}

                </Field>;
            break;
            case 'datetime': {

                input = <Field name={name}>
                    {({field, form: { setFieldValue }}) => {

                        return <DatePicker  {..._.omit(inputProps,['placeholder','disabled'])}
                                            {...field}
                                            className={`form-control form-input-select ${inputClass}`}
                                            isDisabled={props.disabled}
                                            selected={field.value ? moment(field.value).toDate() : field.value}
                                            placeholderText={props.placeholder}
                                            dropdownMode={"scroll"}
                                            onChange={value => setFieldValue(field.name, value)}/>;
                    }}
                </Field>;
            }
            break;
            case 'dropdown': {

                let options = (typeof items === "function" ? items() : items);
                let {
                    simple,
                    autoFocus,
                    openOnFocus,
                    openOnClick,
                    searchable,
                    multi,
                    async,
                    disabled,
                    singleItemRender,
                    dropdownItemRender,
                    ...selectProps
                } = inputProps;

                input = <Field name={name}>
                    {({field, form: {setFieldValue, setFieldTouched}}) => {

                        let value = simple ?
                            (field.value ? field.value.split(",").map(v => ({
                                value: v,
                                label: v
                            })) : (multi ? [] : '')) :
                            (multi ? field.value.map(c => ({
                                value: c,
                                label: inputProps.getItemLabel(c),
                                instance: c
                            })) : field.value);

                        const Component = async ? AsyncSelect : Select;

                        let selectComponents = {};
                        if (singleItemRender) {

                            selectComponents['SingleValue'] = ({children, ...props}) =>
                                <components.SingleValue {...props}>
                                    {singleItemRender(props) || children}
                                </components.SingleValue>;

                        }

                        if (dropdownItemRender) {
                            selectComponents['Option'] = ({children, ...props}) => <components.Option {...props}>
                                {dropdownItemRender(props) || children}
                            </components.Option>;
                        }

                        return <Component name={name}
                                          simpleValue={simple}
                                          components={selectComponents}
                                          isMulti={multi}
                                          onBlurResetsInput={false}
                                          onSelectResetsInput={false}
                                          blurInputOnSelect={false}
                                          options={_.isArray(options) ? options.map(c => ({
                                              ...c,
                                              label: c.text
                                          })) : undefined}
                                          value={value}
                                          isDisabled={disabled}
                                          autoFocus={autoFocus === undefined ? true : autoFocus}
                                          openOnFocus={openOnFocus === undefined ? openOnFocus : false}
                                          openOnClick={openOnClick === undefined ? openOnClick : true}
                                          searchable={searchable === undefined ? searchable : true}
                                          {...selectProps}
                                          onChange={value => {

                                              let _actualValue;
                                              if (simple) {
                                                  _actualValue = multi ? value.map(c => c.value).join(",") : value.value;
                                              } else {
                                                  _actualValue = multi ? value.map(c => c.value) : value;
                                              }

                                              setFieldValue(name, _actualValue);

                                              if (props.onChange)
                                                  props.onChange(_actualValue);
                                          }}
                                          onBlur={evt => {

                                              setFieldTouched(name, true);

                                              if (props.onBlur)
                                                  props.onBlur(evt);
                                          }}/>

                    }}
                </Field>;
            }
            break;
            case 'location':

                input = <Field name={name}
                               render={({ field , form: { setFieldValue  } }) =>
                                   (<AutoComplete
                                       ref={(r) => this._input = r}
                                       style={{width: '100%'}}
                                       types={['(regions)']}
                                       {...field}
                                       {...inputProps}
                                       className={`form-control form-input ${this.state.errorMessage ? "form-input-error" : ""} ${inputClass}`}
                                       onChange={placeFull => {
                                           setFieldValue(name,placeFull);
                                       }}
                                       componentRestrictions={{country: AppVariables.PlacesAutoCompleteCountry }}/>
                               )}/>;
            break;
            case 'phone':

                input = <PhoneNumberInput disabled={props.disabled}
                                          regionKey={`${name}-region`}
                                          includeRegion={true}
                                          inputClassName={`form-control form-input ${inputClass}`}
                                          placeholder={props.placeholder}
                                          name={name}/>;
                break;
            default:

                input = <Field type={type}
                               innerRef={r => this._input = r}
                               className={`form-control form-input ${this.state.errorMessage ? "form-input-error" : ""} ${inputClass}` }
                               name={name}
                               {...inputProps}/>;
                break;
        }

        return (<FormGroup key={name}>
            {title && <div className="clearfix">
            <div className="pull-left">
                <Label for={name}>{HTML.renderIcon(icon)} {title}</Label>
            </div>
                {showPrompt && <Desktop>
                    <div className="pull-right">
                    {<span style={hasRequired ? Styles.requiredInputLabel : Styles.optionalInputLabel}>{ hasRequired  ? "*" :""}</span>}
                </div>
                </Desktop>}

                {titleRightContent && <div className="pull-right">
                    {titleRightContent}
                </div>}

            </div>}
            {_.isFunction(comment) ? comment() : comment}
            {input}
            {showFieldError && <ErrorMessage name={name} className={"input-error mt-1"} component={"div"}/>}
            {children}
            {tipError && <Tooltip isOpen={this.state.isTooltipOpen} target={name} toggle={this.toggleTooltip.bind(this)} autohide={true} placement={"top"} delay={10} className="alert-danger" >{tipError}</Tooltip>}
        </FormGroup>);
    }
}

FormInput.propTypes = {
    name: PropTypes.string,
    icon: PropTypes.string,
    comment: PropTypes.any,
    inputClass: PropTypes.string,
    title: PropTypes.any,
    items: PropTypes.array,
    tipError: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    maxLength: PropTypes.number,
    required: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    showPrompt: PropTypes.bool,
    showFieldError: PropTypes.bool,
    validate: PropTypes.func,
    titleRightContent: PropTypes.any
};

FormInput.defaultProps = {
    type: 'text',
    maxLength: 256,
    disabled: false,
    required: true,
    showPrompt: false,
    showFieldError: true
};

export default  FormInput;


// WEBPACK FOOTER //
// ./src/components/FormInput/FormInput.js